{
  "languages": {
    "arabic": "Арабская",
    "belarusian": "Беларуская",
    "chinese": "Кітайская",
    "dutch": "Галандская",
    "english": "Англійская",
    "french": "Французская",
    "german": "Нямецкая",
    "italian": "Італьянская",
    "japanese": "Японская",
    "korean": "Карэйская",
    "lithuanian": "Літоўская",
    "portuguese": "Партугальская",
    "romanian": "Румынская",
    "spanish": "Іспанская",
    "turkish": "Турэцкая"
  }
}
